import Icon from './src/icon.vue';
import { SFCWithInstall } from '@touchvue/utils';
export declare const ToIcon: SFCWithInstall<typeof Icon>;
export default ToIcon;
export { Icon };
export * from './src/icon.vue';
